export let itemListProps = {
    key: 0,
    id: 0,
    tax_id: 0,
    entry_type: 0,
    description: '',
    amount: 0,
    remarks: '',
    read_only: false
}

export let dataProps = {
    id: 0,
    staff_id: null,
    store_id: null,
    payroll_number: null, 
    payment_date: new Date(), 
    payroll_period: ['', ''], 
    notes: '',
    total_payable: 0,
    status: 0, 
    bank_id: null,

    //misc
    deduction_per_day: 0,
    hour_rate: 0,
    in_time: "",
    out_time: "",
    overtime_list: [],
    //end
    
    production_work_list: [],
    attendance_list: [],
    sales_commission_list: [],
    loan_repayment_list: [],
    payroll_item_list: [],
}


// WEBPACK FOOTER //
// ./src/store/modules/employeePayroll/properties.js